<template>
  <div class="tw:flex tw:flex-col">
    <div
      :class="
        cn(
          'tw:overflow-hidden tw:rounded-md tw:border tw:border-solid tw:border-border-secondary',
          fullSize && 'tw:h-full'
        )
      ">
      <a
        :href="directlink"
        target="_blank"
        :class="
          cn(
            // wrapper link owns the sizing so loading/loaded states never differ in geometry.
            // `group` so the img's darken-on-hover overlay can react.
            'tw:group tw:relative tw:z-[1] tw:block tw:no-underline',
            fullSize ? 'tw:h-full tw:w-full' : 'tw:h-20 tw:w-[90px]'
          )
        ">
        <div v-if="isLoading" class="tw:flex tw:h-full tw:w-full tw:items-center tw:justify-center tw:bg-gray-50">
          <span
            role="status"
            aria-label="Loading"
            class="tw:inline-block tw:size-6 tw:animate-spin tw:rounded-full tw:border-2 tw:border-solid tw:border-gray-400 tw:border-r-transparent tw:motion-reduce:animate-none" />
        </div>
        <img
          v-else
          :src="orderBanner ? orderBanner?.proxy.url_raw : '/svgs/orderBanner.svg'"
          alt=""
          class="tw:block tw:h-full tw:w-full tw:object-cover tw:transition-[filter] tw:duration-150 tw:group-hover:brightness-90" />
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import type { ImageObject, Order } from '@/types/types';
import { fetchUrlPreviewImage } from '@/api/media';
import { useRequestQueue } from '@/api/useQueue';
import { cn } from '@/lib/cn';

const props = withDefaults(defineProps<{ order: Order; fullSize?: boolean }>(), {
  fullSize: false,
});

const { addToQueue } = useRequestQueue();

const orderBanner = ref<ImageObject>();
const isLoading = ref(true);
const { directlink } = props.order || {};

onMounted(() => {
  addToQueue(() =>
    fetchUrlPreviewImage(directlink)
      .then((res) => {
        if (res.image) orderBanner.value = res.image;
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        isLoading.value = false;
      })
  );
});
</script>
